export const SortLegal = 'Sort Legal';
export default (entity) => {
  return entity?.config?.supplier === SortLegal || entity?.supplier_information?.name.includes(SortLegal);
};
